// بديل نطق داخل المتصفح (الويب فقط) عندما لا يستطيع الخادم توليد الصوت.
// داخل تطبيق الجوال لا نستخدمه: صوت النظام الآلي أسوأ من الصمت.
const isNative = () => window.Capacitor?.isNativePlatform?.() === true;

const pickVoice = (lang) => {
  const voices = window.speechSynthesis?.getVoices?.() || [];
  const wanted = lang === "ar" ? "ar" : "en";
  return voices.find((v) => v.lang?.toLowerCase().startsWith(wanted)) || null;
};

export const speakWithBrowser = (text, lang = "ar") =>
  new Promise((resolve) => {
    const synth = window.speechSynthesis;
    if (!synth || !text || isNative()) return resolve(false);
    let settled = false;
    const finish = (value) => {
      if (settled) return;
      settled = true;
      resolve(value);
    };
    try {
      synth.cancel();
      const utterance = new SpeechSynthesisUtterance(text);
      const voice = pickVoice(lang);
      if (voice) utterance.voice = voice;
      utterance.lang = voice?.lang || (lang === "ar" ? "ar-SA" : "en-US");
      utterance.rate = 1.05;
      utterance.pitch = 1.08;
      utterance.onstart = () => finish(true);
      utterance.onend = () => finish(true);
      utterance.onerror = () => finish(false);
      synth.speak(utterance);
      setTimeout(() => finish(Boolean(synth.speaking || synth.pending)), 400);
    } catch {
      finish(false);
    }
  });
